import React from 'react';
import VisualizationDocPage from '@splunk/visualizations-shared/VisualizationDocPage';
import OptionsDoc from '@splunk/dashboard-visualizations/common/OptionsDoc';
import DocExample from '@splunk/react-docs/DocExample';

import BasicExampleCode from '!!raw-loader!./examples/Basic';
import PreserveExampleCode from '!!raw-loader!./examples/Preserve';
import RemoteImageExampleCode from '!!raw-loader!./examples/RemoteImage';

import BasicExample from './examples/Basic';
import PreserveExample from './examples/Preserve';
import RemoteImageExample from './examples/RemoteImage';
import optionsSchema from '../optionsSchema';

export default () => (
    <VisualizationDocPage
        title="Image"
        examplesSection={[
            <DocExample
                title="Basic Image"
                key="basic"
                description="Image example."
                code={BasicExampleCode}
                example={BasicExample}
            />,
            <DocExample
                title="Preserve Image"
                key="preserve"
                description="Image example with preserveAspectRatio=true."
                code={PreserveExampleCode}
                example={PreserveExample}
            />,
            <DocExample
                title="Persisted Image in ImageRegistry"
                key="remoteImage"
                description="Image example with remote image key"
                code={RemoteImageExampleCode}
                example={RemoteImageExample}
            />,
        ]}
        optionSection={<OptionsDoc options={optionsSchema} />}
    />
);
